/**
 * Build-time parent protocol only — no imports from `@/common/bridge` (avoids store ↔ parent-bridge cycles).
 */
declare const GLOBAL_PARENT_BRIDGE_MODE: string;

export enum PARENT_BRIDGE_MODES {
  LEGACY_SDK = 'legacy_sdk',
  MODERN_SDK = 'modern_sdk',
}

export const getParentBridgeMode = (): PARENT_BRIDGE_MODES => {
  if (GLOBAL_PARENT_BRIDGE_MODE === PARENT_BRIDGE_MODES.MODERN_SDK) {
    return PARENT_BRIDGE_MODES.MODERN_SDK;
  }
  return PARENT_BRIDGE_MODES.LEGACY_SDK;
};

export const isModernBridge = (): boolean => getParentBridgeMode() === PARENT_BRIDGE_MODES.MODERN_SDK;
